import axios from 'axios'
import { costUrl, getHeader } from '@/config'

const state = {
  costTypeList: [],
  costCategoryList: []
}

const mutations = {
  SET_COST_TYPE_LIST (state, obj) {
    state.costTypeList = obj
  },
  SET_COST_CATEGORY_LIST (state, obj) {
    state.costCategoryList = obj
  }
}

const actions = {
  getCostTypeList: ({ commit }) => {
    axios.get(costUrl + '/type', { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_COST_TYPE_LIST', response.data.data)
      })
  },
  getCostCategoryList: ({ commit }) => {
    axios.get(costUrl + '/category', { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_COST_CATEGORY_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
